import React from 'react';
import { Link } from 'react-router-dom';
import { LevelBadge } from './LevelBadge';
import { StarRating } from './StarRating';

interface LenderMetaRowProps {
  username: string;
  level: number;
  averageRating: number;
  ratingCount: number;
  userId?: number;
}

export const LenderMetaRow: React.FC<LenderMetaRowProps> = ({
  username,
  level,
  averageRating,
  ratingCount,
  userId,
}) => (
  <div className="lender-meta">
    <span className="lender-meta-identity">
      {userId != null ? (
        <Link
          to={`/user/${userId}`}
          className="lender-meta-name"
          onClick={e => e.stopPropagation()}
        >
          {username}
        </Link>
      ) : (
        <span className="lender-meta-name">{username}</span>
      )}
      <LevelBadge level={level} size="sm" />
    </span>
    <span className="lender-meta-rating">
      <StarRating value={averageRating} size="sm" />
      <span className="text-muted lender-meta-rating-text" style={{ marginBottom: '0rem' }}>
        {averageRating.toFixed(1)} ({ratingCount})
      </span>
    </span>
  </div>
);
